import { createRouter, createWebHistory } from "vue-router";
import LoginForm from "../components/LoginForm.vue";
import UploadForm from "../components/UploadForm.vue";

const routes = [
  { path: "/", redirect: "/login" },
  { 
    path: "/login", 
    name: "Login", 
    component: LoginForm 
  },
  { 
    path: "/upload", 
    name: "Upload", 
    component: UploadForm,
    meta: { requiresAuth: true }, // Add meta field for routes that need authentication
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Navigation Guard
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    // Check if session or auth token exists
    const isLoggedIn = document.cookie.includes("session="); // Assuming session cookie is named 'session'

    if (isLoggedIn) {
      next(); // Proceed to the route
    } else {
      alert("Unauthorized: Please log in first.");
      next("/login"); // Redirect to login page
    }
  } else {
    next(); // Proceed to the route if no auth required
  }
});

export default router;
